module.exports = __webpack_public_path__ + "img/2.9067c8d6.png";